import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const DoctorOrderBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="bg-blue-500 font-semibold text-white">
      {t('component:badge.doctorOrder')}
    </Badge>
  );
};
